module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/NG-9bee5b4e054cfa6f69f5b975101e4a33.png";